import React from 'react';
import { INGREDIENT_SHOP, BUFF_SHOP } from '../../../data/regionalChef/shopData';
import { recipesData } from '../../../data/regionalChef/recipesData'; 

const ShopPhase = ({ gameLogic }) => {
  const { 
    day, money, dailyTarget, masterDeck, activeBuffs, currentModifier, 
    bonusSummary, maxBuffSlots, unlockedRecipes, recipeLevels, isKidsMode, // 👈 ดึง isKidsMode มา
    buyIngredient, buyBuff, upgradeRecipe, startNextDay 
  } = gameLogic;

  const nextTarget = Math.floor(dailyTarget * 1.5);
  const requiredCards = isKidsMode ? 6 : 4; // 👈 ถ้าเป็นโหมดเด็กต้องซื้อให้ครบ 6 ใบ

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif', padding: '20px', paddingBottom: '80px' }}>
      
      <div style={{ backgroundColor: '#2ed573', color: 'white', padding: '20px', borderRadius: '12px', textAlign: 'center', marginBottom: '20px', boxShadow: '0 4px 15px rgba(46, 213, 115, 0.3)' }}>
        <h2 style={{ margin: '0 0 10px 0' }}>🎉 ผ่านวันที่ {day} ยอดทะลุเป้า!</h2>
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '15px' }}>
            <div style={{ textAlign: 'center' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#e8f8f5' }}>เงินทุนปัจจุบัน</p>
                <p style={{ margin: 0, fontSize: '28px', color: '#ffffff' }}><strong>฿{money}</strong></p>
            </div>
            
            <div style={{ borderLeft: '2px solid rgba(255,255,255,0.3)', paddingLeft: '30px', textAlign: 'center' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#e8f8f5' }}>🎯 เป้าหมาย (Day {day + 1})</p>
                <p style={{ margin: 0, fontSize: '28px', color: '#feca57' }}><strong>฿{nextTarget}</strong></p>
            </div>
        </div>

        <hr style={{ borderColor: 'rgba(255,255,255,0.3)', margin: '15px 0' }}/>
        <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
          <p style={{ margin: 0 }}>พลังงานเหลือ ({bonusSummary?.apBonus / 10} AP): +฿{bonusSummary?.apBonus}</p>
          <p style={{ margin: 0 }}>วัตถุดิบเก็บไว้ใช้วันพรุ่งนี้: {bonusSummary?.leftoverCardsCount} ใบ</p>
          <h4 style={{ margin: '5px 0 0 0' }}>รวมโบนัสที่ได้รับ: +฿{bonusSummary?.totalBonus}</h4>
        </div>
      </div>

      <div style={{ backgroundColor: currentModifier.color, color: 'white', padding: '15px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
        ⚠️ เงื่อนไขด่านถัดไป: {currentModifier.name} - {currentModifier.desc}
      </div>

      <div style={{ backgroundColor: '#fff3cd', color: '#856404', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #ffeeba' }}>
        <strong>📦 คลังวัตถุดิบ:</strong> วัตถุดิบและอาหารที่เหลือจากเมื่อวานถูกเก็บเข้ากองการ์ดของคุณแล้ว! คุณสามารถซื้อของสดเพิ่มเพื่อเติมเด็คสำหรับวันนี้ได้
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
         <h3 style={{ margin: 0 }}>🛒 ซื้อวัตถุดิบเพิ่ม</h3>
         {/* ⚠️ แสดงเป้าหมายขั้นต่ำตาม Mode */}
         <span style={{ fontWeight: 'bold', color: masterDeck.length >= requiredCards ? '#2ed573' : '#ff4757' }}>ไพ่บนมือรวม: {masterDeck.length} ใบ</span>
      </div>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '30px' }}>
        {INGREDIENT_SHOP.map(item => {
          const countInDeck = masterDeck.filter(id => id === item.id).length;
          return (
            <div key={item.id} style={{ border: '2px solid #dfe4ea', padding: '10px', borderRadius: '8px', textAlign: 'center', width: '110px', position: 'relative' }}>
              {countInDeck > 0 && (
                <div style={{ position: 'absolute', top: '-10px', right: '-10px', backgroundColor: '#ff4757', color: 'white', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: '12px' }}>
                  {countInDeck}
                </div>
              )}
              <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>{item.name}</h4>
              <p style={{ margin: '0 0 10px 0', color: '#ff4757', fontWeight: 'bold' }}>฿{item.price}</p>
              <button 
                onClick={() => buyIngredient(item.id, item.price)} disabled={money < item.price}
                style={{ width: '100%', padding: '5px 10px', backgroundColor: money >= item.price ? '#ffa502' : '#ccc', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
              >
                ซื้อ
              </button>
            </div>
          );
        })}
      </div>

      <h3 style={{ margin: '0 0 10px 0' }}>📖 อัปเกรดสูตรอาหาร (+฿15/Lv)</h3>
      <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '30px' }}>
        {unlockedRecipes.length === 0 ? (
          <p style={{ color: '#a4b0be', fontSize: '14px', fontStyle: 'italic' }}>ยังไม่มีสูตรอาหารให้อัปเกรด (ต้องค้นพบในเกมก่อน)</p>
        ) : (
          unlockedRecipes.map(id => {
             const recipe = recipesData[id];
             const currentLv = recipeLevels[id] || 1;
             const upgradeCost = currentLv * 50; 
             return (
                <div key={id} style={{ border: '2px solid #dfe4ea', padding: '10px', borderRadius: '8px', minWidth: '160px', backgroundColor: '#f8f9fa' }}>
                   <h4 style={{ margin: '0 0 5px 0' }}>{recipe.name}</h4>
                   <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#ffa502', fontWeight: 'bold' }}>Lv.{currentLv} ➡️ Lv.{currentLv + 1}</p>
                   <p style={{ margin: '0 0 10px 0', color: '#ff4757', fontWeight: 'bold' }}>฿{upgradeCost}</p>
                   <button 
                     onClick={() => upgradeRecipe(id, upgradeCost)} disabled={money < upgradeCost} 
                     style={{ width: '100%', padding: '5px', backgroundColor: money >= upgradeCost ? '#3742fa' : '#ccc', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                   >
                     ซื้อตำรา
                   </button>
                </div>
             )
          })
        )}
      </div>

      <h3 style={{ margin: '0 0 10px 0' }}>🛠️ อุปกรณ์ก้นครัว ({activeBuffs.length}/{maxBuffSlots})</h3>
      <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '30px' }}>
        {BUFF_SHOP.map(item => {
          const hasBuff = activeBuffs.includes(item.id);
          const isFull = activeBuffs.length >= maxBuffSlots && !hasBuff;
          return (
            <div key={item.id} style={{ border: '2px solid #dfe4ea', padding: '10px', borderRadius: '8px', minWidth: '200px' }}>
              <h4 style={{ margin: '0 0 5px 0' }}>{item.name}</h4>
              <p style={{ fontSize: '12px', margin: '0 0 10px 0', minHeight: '34px', color: '#57606f' }}>{item.desc}</p>
              <p style={{ margin: '0 0 10px 0', color: '#ff4757', fontWeight: 'bold' }}>฿{item.price}</p>
              <button 
                onClick={() => buyBuff(item.id, item.price)} disabled={money < item.price || hasBuff || isFull}
                style={{ width: '100%', padding: '8px', backgroundColor: hasBuff ? '#2ed573' : (money >= item.price && !isFull ? '#3742fa' : '#ccc'), color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
              >
                {hasBuff ? 'มีแล้ว' : (isFull ? 'ช่องเต็ม' : 'ซื้ออุปกรณ์')}
              </button>
            </div>
          );
        })}
      </div>

      {/* ⚠️ ล็อกปุ่มถ้าไพ่ยังไม่ครบ 6 ใบในโหมดเด็ก */}
      <div style={{ position: 'sticky', bottom: '20px', zIndex: 10 }}>
        <button 
          onClick={() => startNextDay(false)}
          disabled={masterDeck.length < requiredCards}
          style={{ width: '100%', padding: '15px', fontSize: '18px', backgroundColor: masterDeck.length >= requiredCards ? '#ff4757' : '#a4b0be', color: 'white', border: 'none', borderRadius: '8px', cursor: masterDeck.length >= requiredCards ? 'pointer' : 'not-allowed', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}
        >
          {masterDeck.length >= requiredCards ? `เริ่มวันที่ ${day + 1} 🚀` : `ต้องมีไพ่อย่างน้อย ${requiredCards} ชิ้น`}
        </button>
      </div>

    </div>
  );
};

export default ShopPhase;